<template>
  <div>
    <iframe
      src="https://siteware.revitest.cz"
      style="height: 100vh"
      width="100%"
      height="100%"
      allowfullscreen
      >
      <p>
        <a href="/en-US/docs/Glossary">
          Fallback link for browsers that don't support iframes
        </a>
      </p>
    </iframe>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemsHelpers from '../helpers/items-helpers.es6'

export default {
  mixins: [displayHelpers, itemsHelpers],
  data () {
    return {
      model: {
        name: 'visuals'
      }
    }
  },
  methods: {
    routeToVisual (id, initVisualMode) {
      this.$router.push({ name: 'visuals/id', params: { id: id, initVisualMode: initVisualMode } })
    },
    async createNewVisual () {
      try {
        await this.$store.dispatch('updateItem', { modelName: this.model.name, item: { id: null } })
        await this.storeUpdate()
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
